const restaurantReducer = (state = [], {type, restaurants}) => {
    switch(type) {
        case 'SET_RESTAURANTS':
            return restaurants;
        default: 
            return state;
    }
}

export default restaurantReducer;